import { get, post, put } from '../actions/common';
import {
    flattenRpmDeviceOptions,
    parseAddressValidationResponse,
} from '../utils/rpmEnrollmentHelpers';

export const fetchRpmDevices = (deviceType, connectionType) =>
    get(`/v1/rpm/devices?device_type=${encodeURIComponent(deviceType)}`)
        .then((result) => flattenRpmDeviceOptions(result, connectionType));

export const validateRpmShippingAddress = (address) => {
    const line1 = (address.address1 || '').trim();
    if (!line1 || !address.city || !address.state || !address.zip_code) {
        return Promise.resolve({
            status: 'invalid',
            error: 'Complete all required address fields before validating.',
        });
    }
    if (/P\.?\s*O\.?\s*Box/i.test(line1) || /^POB/i.test(line1)) {
        return Promise.resolve({
            status: 'invalid',
            error: 'PO Box addresses are not allowed for device shipping.',
        });
    }

    const addressLines = [line1];
    if (address.address2 && address.address2.trim()) {
        addressLines.push(address.address2.trim());
    }

    return post('/v1/rpm/validate_address', {
        address_lines: addressLines,
        city: address.city,
        state: address.state,
        zip_code: address.zip_code,
    }).then(parseAddressValidationResponse);
};

export const enrollRpmPatient = (patientId, payload) =>
    put(`/v1/rpm/patients/${patientId}/enroll`, payload);

export const optOutRpmPatient = (patientId, rpmOptoutReasonId, rpmOptoutNote) =>
    post(`/v1/rpm/patients/${patientId}/optout`, {
        rpm_optout_reason_id: rpmOptoutReasonId,
        rpm_optout_note: rpmOptoutNote || '',
    });

export const fetchRpmOptOutReasons = () => get('/v1/rpm/optoutreasons');
